import * as t from 'io-ts';

import { dbModelId, mkRestEndpoint } from '@main/schema-utils';

import {
  ConsentLastKey,
  PreferencesBody,
  PreferenceStoreRecord,
  QueryConsentPreferencesResponse,
} from './codecs';

/** Preference Management Service Routes */

export const getConsentPreferences = mkRestEndpoint({
  route: '/sync',
  method: 'GET',
  body: t.undefined,
  headers: t.type({
    authorization: t.string,
  }),
  responseBody: PreferenceStoreRecord,
});

export const updateConsentPreferences = mkRestEndpoint({
  route: '/sync',
  method: 'POST',
  body: PreferencesBody,
  headers: t.type({
    authorization: t.string,
  }),
  responseBody: PreferenceStoreRecord,
});

export const queryConsentPreferences = mkRestEndpoint({
  method: 'POST',
  route: '/v1/preferences/:partition/query',
  body: t.type({
    organizationId: t.union([dbModelId('organization'), t.undefined]),
    identifiers: t.union([
      t.array(
        t.type({
          name: t.string,
          value: t.string,
        }),
      ),
      t.undefined,
    ]),
    timestampBefore: t.union([t.string, t.undefined]),
    timestampAfter: t.union([t.string, t.undefined]),
    updatedBefore: t.union([t.string, t.undefined]),
    updatedAfter: t.union([t.string, t.undefined]),
    lastKey: t.union([t.undefined, ConsentLastKey]),
    limit: t.union([t.number, t.undefined]),
  }),
  headers: t.type({
    authorization: t.union([t.undefined, t.string]),
  }),
  responseBody: QueryConsentPreferencesResponse,
});

export const deleteCacheValues = mkRestEndpoint({
  route: '/v1/cache/values',
  method: 'DELETE',
  body: t.type({
    cacheKeys: t.array(t.string),
  }),
  headers: t.type({
    'x-transcend-token': t.string,
  }),
  responseBody: t.type({
    success: t.boolean,
    numValuesDeleted: t.number,
  }),
});
